export default __webpack_public_path__ + "navigation-examples-custom-destination-marker-thumbnail-v1-960-5759870f363b89b31e146e4760ccd307.webp";